import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useEffectOnce } from 'react-use';
import { CollectionType } from '../../../data-layer/collections/service';
import { useCollectionsController } from '../useCollectionsController';

export const useCollectionsTabs = () => {
    const { savedCollections, createdCollections, isLoading, loadCollections } =
        useCollectionsController();

    const [query, setQuery] = useSearchParams();

    const collectionType = (
        query.get('collectionType') === CollectionType.SAVED
            ? CollectionType.SAVED
            : CollectionType.CREATED
    ) as CollectionType;

    const onChangeTab = (type: CollectionType) => {
        setQuery({ collectionType: type }, { replace: true });
    };

    useEffect(() => {
        const needChangeQuery = Boolean(
            !isLoading &&
                !savedCollections.length &&
                createdCollections.length &&
                createdCollections[0] &&
                collectionType !== CollectionType.CREATED,
        );

        if (needChangeQuery) {
            setQuery({ collectionType: CollectionType.CREATED }, { replace: true });
        }
    }, [
        collectionType,
        createdCollections,
        createdCollections.length,
        isLoading,
        savedCollections.length,
        setQuery,
    ]);

    useEffectOnce(() => {
        loadCollections();
    });

    return {
        hasTabs: Boolean(savedCollections.length),
        collectionType,
        onChangeTab,
    };
};
